import { ThunkDispatch as Dispatch } from "redux-thunk";
import { Actions } from "./types";
import { ACTION_TYPES } from "./constants";
import { State } from "../types";
import { CollateralMintName as SolanaCollateralMintName } from "../config/solana.types";

// Because all collateral used with solana are USDC-like, collateral price is always 1
function getSolanaCollateralPerpPrice() {
  return "1";
}

export const getCollateralPerpPriceAction =
  (collateralMintName: SolanaCollateralMintName) =>
  async (
    dispatch: Dispatch<State, void, Actions.GetCollateralPerpPriceAction>
  ) => {
    let getPriceFunction = (): ReturnType<
      typeof getSolanaCollateralPerpPrice
    > => {
      throw new Error("Unreachable");
    };
    switch (window.__UXD__.config.chain) {
      case "solana":
      default:
        getPriceFunction = getSolanaCollateralPerpPrice;
    }

    const price = getPriceFunction();

    dispatch({
      type: ACTION_TYPES.SET_COLLATERAL_PRICE,
      payload: {
        [collateralMintName]: price,
      },
    });

    return price;
  };
